export default {
  localUser: () => {
    let hasLocalStorageUser = false
    for (let key in localStorage) {
      if (key.startsWith('firebase:authUser:')) {
        hasLocalStorageUser = true
      }
    }
    return hasLocalStorageUser
  },
  mobileDevice: () => {
    let mobile = false
    let regex = new RegExp(
      [
        'Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry',
        '|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini'
      ].join('')
    )

    if (regex.test(navigator.userAgent)) {
      mobile = true
    }

    return mobile
  }
}



// WEBPACK FOOTER //
// ./src/app/filters/sessions.js